import { createSlice } from "@reduxjs/toolkit"

export const countryListSlice = createSlice({

	name: "country_list",
	initialState: {
		country: "",
		errors: [],
	},

	reducers: {
        getCountry: (state, action) => {
            // console.log(action.payload);
			state.country = action.payload
		},
		getCountryList: (state, action) => {
            
			state.country = action.payload
		},
		getErrors: (state, action) => {
            // console.log(action.payload);
			state.errors = action.payload
		},
	},
})
export const {getCountry, getCountryList, getErrors} = countryListSlice.actions

export default countryListSlice.reducer
